import { IMaintenanceProcessRule } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import { useRecoilValue } from 'recoil'
import maintenanceProcessesAtom from '@/pages/Processes/Maintenance/MaintenanceProcesses/maintenanceProcesses.atom.ts'

const useMaintenanceProcessRule = (id: IMaintenanceProcessRule['id']) => {
  const processes = useRecoilValue(maintenanceProcessesAtom).items

  return processes.flatMap((p) => p.rules).find((it) => it.id === id)
}

export default useMaintenanceProcessRule
